import { ICustomerUserInitialState } from "../../types/customerUserInterface";
import { CustomerUserActions, CustomerUserActionTypes } from "../actionTypes/customerUserActionTypes";

const initialState: ICustomerUserInitialState = {
  loading: false,
  error: null,
  customerUserList: [],
  customerUserListPageCount: 0,
  customerUserData: {
    id: 0,
    name: "",
    username: "",
    password: "",
    customer_id: "",
    role: "",
    last_login_at: "",
    profile_status: "",
    customer_data: {
      id: 0,
      company_name: "",
      profile_status: "",
    },
  },
  authStatus: false, 
  myProfile: null, 
  loggedInCustomerUserData: null, 
};


export default function CustomerUserReducer(state = initialState, action: CustomerUserActionTypes): ICustomerUserInitialState {
  switch (action.type) {
    case CustomerUserActions.SET_CUSTOMER_USER:
      return {
        ...state,
        authStatus: true,
        myProfile: action.payload,
      };

    case CustomerUserActions.SET_CUSTOMER_USER_LIST:
      return {
        ...state,
        customerUserList: action.payload,
      };

    case CustomerUserActions.SET_CUSTOMER_USER_LIST_PAGE_COUNT:
      return {
        ...state,
        customerUserListPageCount: action.payload,
      };

    case CustomerUserActions.SET_CUSTOMER_USER_DATA_BY_ID:
      return {
        ...state,
        customerUserData: action.payload,
      };

    case CustomerUserActions.SET_LOGGEDIN_CUSTOMER_USER_DATA:
      return {
        ...state,
        loggedInCustomerUserData: action.payload,
      };
    default:
      return state;
  }
}
